module.exports = {"445102001":"湘桥街道","445102002":"西湖街道","445102003":"金山街道","445102004":"太平街道","445102005":"南春街道","445102006":"西新街道","445102007":"桥东街道","445102008":"城西街道","445102009":"凤新街道","445102100":"意溪镇","445102111":"磷溪镇","445102112":"铁铺镇","445102113":"官塘镇","445102400":"红山林场","445102401":"开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445102.json
// module id = 2056
// module chunks = 0